import {useUpmPlantNow} from '@hconnect/upm'
import {Moment} from 'moment-timezone'
import {useMemo, useState} from 'react'
import {useInterval} from 'react-use'

const INTERVAL_MS = 1000 * 30

interface CurrentTimeRoundedParams {
  roundingFn: (datetime: Moment) => Moment
}

export const useCurrentTimeRounded = ({roundingFn}: CurrentTimeRoundedParams) => {
  const getNow = useUpmPlantNow()
  const [, setTick] = useState(0)

  useInterval(() => {
    setTick((t) => t + 1)
  }, INTERVAL_MS)

  const nowRoundedISO = roundingFn(getNow()).toISOString()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => roundingFn(getNow()), [nowRoundedISO])
}
